import type { ErrorCopy } from '@shared/errors/catalog';

/**
 * The `error_code` values only this surface meets, in the `CONTENT_` namespace.
 * Codes more than one feature meets live in `@shared/errors/catalog.ts`, and
 * every status with no code of its own falls through to that file's table.
 *
 * **Never inline a backend code in JSX.** The code is a log key; what reaches
 * the operator is the sentence, and the `X-Request-ID` is what they quote.
 *
 * The three `422`s below are one family and are worth reading together: all
 * three fire when a write names something outside a **configured** vocabulary,
 * and in every case the fix is a configuration write on the settings surface
 * rather than a correction here. The copy says so, because an operator told
 * only «invalid» would go looking for the mistake in the field they just typed.
 */
export const errors: Readonly<Record<string, ErrorCopy>> = {
  CONTENT_SHELF_SOURCE_NOT_CONFIGURED: {
    message: 'هذا المصدر غير مُدرَج في المصادر المسموح بها. أضِفه من صفحة الإعدادات ثمّ أعد المحاولة.',
    tone: 'warning',
  },
  CONTENT_SHELF_LAYOUT_NOT_CONFIGURED: {
    message: 'شكل هذا الرفّ غير مُدرَج في الأشكال المسموح بها. راجع صفحة الإعدادات.',
    tone: 'warning',
  },
  CONTENT_SHELF_SOURCE_PARAMETER_INVALID: {
    message:
      'التحديد لا يوافق هذا المصدر. اختر من القائمة المعروضة، أو انزع التحديد إن كان المصدر يحلّ بنفسه.',
    tone: 'warning',
  },
  /** A shelf another operator removed between the read and the click. */
  CONTENT_NOT_FOUND: {
    message: 'لم نعثر على هذا الرفّ. قد يكون حُذف من نافذة أخرى — أعد تحميل الصفحة.',
    tone: 'warning',
  },
};
